// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__1LduR","switch":"Toggle_switch__2TpQO","checkbox":"Toggle_checkbox__27C8T"};